export default {
  information_updated: 'Данные успешно обновлены',
  updated: '{msg} был обновен',
  toggle: '{msg} был установлен статус {status}',
  removed: '{msg} был удален',
  reset: '{msg} был сброшен',
  stopped: '{msg} Сигнал на остановку отправлен',
  restarted: '{msg} Сигнал на перезапуск отправлен',
  uploaded: 'Файл успешно загружен',
  saved: '{title} был сохранен',
  listSaved: 'Список был сохранен',
  listItemSaved: 'Элемента был сохранен',
  added: '{msg} был добавлен',
  new: 'Новая {msg}',
  message: '{msg}',
  serverWas: 'Сигнал на {status} сервера "{server}" отправлен...',
  pipelineWas: 'Пайплайн "{pipeline}" {status}',
  moduleWas: 'Модуль "{module}" {status}',
  userWas: 'Пользователь "{user}" {status}',
  user: {
    removed: 'удален',
    updated: 'обновен',
    saved: 'сохранен',
    added: 'добавлен',
    deleted: 'удален'
  },
  server: {
    running: 'ЗАПУСК',
    stopped: 'ОСТАНОВКУ',
    deleted: 'УДАЛЕНИЕ'
  },
  default: {},
  danger: {},
  success: {},
  info: {}
}
